import { defineMessages } from 'react-intl'

export default defineMessages({
  userActivitySectionTitle: {
    id: 'SpaceAnalyticsPage.Section.UserActivity.Title',
    defaultMessage: 'Member Usage'
  },

  titleSubText: {
    id: 'SpaceAnalyticsPage.Section.UserActivity.SubText',
    defaultMessage:
      'Includes digital assistant usage from across all clients (note: Total Activity excludes Microsoft Teams). See analytics overviews below for additional usage metrics.'
  },

  totalSpaceMembersMetricTitle: {
    id: 'SpaceAnalyticsPage.Section.Metric.TotalSpaceMembers.Title',
    defaultMessage: 'Total Space Members'
  },

  activeNowMetricTitle: {
    id: 'SpaceAnalyticsPage.Section.Metric.ActiveNow.Title',
    defaultMessage: 'Engaged Now'
  },

  sessionsMetricTitle: {
    id: 'SpaceAnalyticsPage.Section.Metric.Sessions.Title',
    defaultMessage: 'Sessions'
  },

  totalEngagementsMetricTitle: {
    id: 'SpaceAnalyticsPage.Section.Metric.TotalEngagement.Title',
    defaultMessage: 'Engagement'
  },

  uniqueActiveUsersMetricTitle: {
    id: 'SpaceAnalyticsPage.Section.Metric.UniqueActiveMembers.Title',
    defaultMessage: 'Unique Engaged Members'
  },

  shortActivityTitle: {
    id: 'SpaceAnalyticsPage.Section.shortTotalActivityTitle.Message',
    defaultMessage: 'Total'
  },

  shortUniqueActivityTitle: {
    id: 'SpaceAnalyticsPage.Section.shortUniqueActivityTitle.Message',
    defaultMessage: 'Unique'
  },

  missingName: {
    id: 'SpaceAnalyticsPage.Section.missingName.Message',
    defaultMessage: 'Missing Data Point'
  }
})
